<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container v-show="Details">
        <v-card style="border: 1px solid">
          <v-toolbar
              :color="appColor">
            <v-card-title class="headline mb-1">
              <span style="color:white"> ลงทะเบียนเข้าร่วม</span>
            </v-card-title>
          </v-toolbar>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12">
                <v-expand-transition>
                  <v-card v-if="!Details_Cordi"
                          style="border: 1px solid"
                  >
                    <v-row
                        justify="center"
                        class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="12">
                        <v-list>
                          <v-list-item class="justify-center">
                            <div align="center">
                              <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
                            </div>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel" :key="fiscalYear.year" @change="selProjFiscalYear">
                              <v-radio :value="fiscalYear.year" class="font-weight-bold" :label="('' + fiscalYear.yearth)"></v-radio>
                            </v-radio-group>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-dialog
                                v-model="dialog_create"
                                persistent
                                max-width="700"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="elevation-2 text-h6 font-weight-bold"
                                  color="green"
                                  large
                                  rounded
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon left>mdi-account-plus</v-icon>
                                  จัดลงทะเบียน
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title class="headline">
                                  <span>แบบฟอร์มการจัดลงทะเบียน</span>
                                </v-card-title>
                                <v-card-text>
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="12">
                                      <v-autocomplete
                                          v-model="Project_code_reg"
                                          :items="projectDataToTable"
                                          item-text="full_Name"
                                          item-value="idx"
                                          label="เลือกงาน / กิจกรรม"
                                          :error="Project_code_reg == null"
                                          :error-messages="Project_code_reg == null ? '*' : ''"
                                          v-if="projectDataToTable.length > 0"
                                      >
                                        <template v-slot:item="{item}">
                                          <div v-html="item.full_Name"></div>
                                        </template>
                                        <template v-slot:selection="{item}">
                                          <div v-html="item.full_Name"></div>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="round"
                                          label="รอบที่"
                                          counter
                                          maxlength="5"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="round_name"
                                          label="ชื่อรอบ (ถ้ามี)"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="3">
                                      <v-text-field
                                          v-model="dateReg"
                                          label="วันที่เริ่มต้น"
                                          type="date"
                                          :error="dateReg == ''"
                                          :error-messages="dateReg == '' ? '*' : ''"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="3">
                                      <v-text-field
                                          v-model="dateEndReg"
                                          label="วันที่สิ้นสุด"
                                          type="date"
                                          :error="dateEndReg == ''"
                                          :error-messages="dateEndReg == '' ? '*' : ''"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="3">
                                      <v-text-field
                                          v-model="time_start"
                                          label="เวลาเริ่มต้น"
                                          type="time"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="3">
                                      <v-text-field
                                          v-model="time_end"
                                          label="เวลาสิ้นสุด"
                                          type="time"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                      color="green darken-1"
                                      text
                                      @click="CreateProject()"
                                  >
                                    ยืนยัน
                                  </v-btn>
                                  <v-btn
                                      color="red darken-1"
                                      text
                                      @click="dialog_create = false"
                                  >
                                    ยกเลิก
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-list-item>
                        </v-list>
                        <v-card-title>
                          ตารางข้อมูลรายละเอียดงาน / กิจกรรม
                          <v-spacer></v-spacer>
                          <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="ค้นหางาน / กิจกรรม"
                              single-line
                              hide-details
                          ></v-text-field>
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <v-row
                        justify="center"
                        class="justify-center">
                      <v-col
                          cols="12"
                          md="12"
                      >

                        <!--                        @click:row="GetData"-->
                        <v-data-table
                            :headers="courseHeaders"
                            :items="projectRegDataDump"
                            :search="search"
                            item-key="D_Project_Register_id"
                            :single-expand="singleExpand"
                            :expanded.sync="expanded"
                            class="elevation-1"
                        >
                          <template v-slot:header.full_Name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              งาน / กิจกรรม
                            </v-label>
                          </template>
                          <template v-slot:header.dateReg>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              วันที่เริ่มต้น
                            </v-label>
                          </template>
                          <template v-slot:header.dateEndReg>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              วันที่สิ้นสุด 
                            </v-label>
                          </template>
                          <template v-slot:header.time_start>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              เวลาเริ่ม
                            </v-label>
                          </template>
                          <template v-slot:header.time_end>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              เวลาสิ้นสุด
                            </v-label>
                          </template>
                          <template v-slot:item.full_Name="{ item }">
                            <div v-html="item.full_Name"></div>
                            <div style="margin-top: -12px; color: #364eff;">
                              <template v-if="item.round">
                              <span>รอบที่ {{ item.round }}</span>
                              </template>
                              <template v-if="item.round_name">
                              <span v-if="item.round"> | </span>
                              <span>ชื่อรอบ {{ item.round_name }}</span>
                              </template>
                            </div>
                          </template>
                          <template v-slot:item.dateReg="{ item }">
                            <span v-if="item.dateReg != '0000-00-00'">{{ item.dateReg | dateToThai }}</span>
                            <span v-else> - </span>
                          </template>
                          <template v-slot:item.time_start="{ item }">
                            <span v-if="item.time_start != '00:00:00'">{{ item.time_start }}</span>
                            <span v-else> - </span>
                          </template>
                          <template v-slot:item.time_end="{ item }">
                            <span v-if="item.time_end != '00:00:00'">{{ item.time_end }}</span>
                            <span v-else> - </span>
                          </template>
                          <template v-slot:item.Project_Details="{ item }">
                            <v-btn
                                text
                                class="darken-3"
                                color="green"
                                @click="showDetails(item)"
                            >
                              ลงทะเบียนเข้าร่วม
                            </v-btn>
                            <v-btn
                                text
                                class="darken-3"
                                color="red"
                                @click="DelRoundProject(item)"
                            >
                              ลบ
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-list-item>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="12">
                <template v-if="Details_Cordi">

                  <v-list-item>
                    <v-btn
                        outlined
                        color="#FF5722"
                        @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                  </v-list-item>

                  <v-card class="justify-center pa-6 mt-7">
                    <v-card-title
                        color="primary"
                        style="background-color: burlywood"
                    >
                      <div v-html="project.full_Name"></div>
                    </v-card-title>

                    <v-card-text>
                      <v-tabs
                          v-model="tab"
                          background-color="transparent"
                          color="basil"
                          show-arrows
                      >
                        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                        <v-tab>
                          บุคลากรคณะแพทย์
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะแพทย์
                        </v-tab>
                        <v-tab>
                          บุคลากรคณะอื่น
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะอื่น
                        </v-tab>
                        <v-tab>
                          บุคคลภายนอก
                        </v-tab>
                        <v-tab>
                          นักศึกษาภายนอก
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-list-item>
                            <v-row class="justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-radio-group v-model="TypeInsert" row>
                                  <v-radio label="สแกนบัตร" value="0"></v-radio>
                                  <v-radio label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                  <!--                                  <v-radio label="ค้นหาโดยตัวเลือก"-->
                                  <!--                                           value="2" disabled></v-radio>-->
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '0'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-text-field
                                    v-if="project != null && project.Status_Type_Reg2 == '0'"
                                    ref="cardSel"
                                    color="black"
                                    v-model="cardSel"
                                    label="สแกนบัตรบุคลากร, บัตรนักศึกษา"
                                    hint="กด Enter เพื่อเป็นการลงทะเบียนเข้าร่วม"
                                    persistent-hint
                                    clearable
                                    outlined
                                    type="password"
                                    @keyup="ChooseEmpolyee_c_unlock"
                                ></v-text-field>
                                <v-text-field
                                    v-else
                                    ref="cardSel"
                                    color="black"
                                    v-model="cardSel"
                                    label="สแกนบัตรบุคลากร, บัตรนักศึกษา"
                                    hint="กด Enter เพื่อเป็นการลงทะเบียนเข้าร่วม"
                                    persistent-hint
                                    clearable
                                    outlined
                                    type="password"
                                    @keyup="ChooseEmpolyee_c"
                                ></v-text-field>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-autocomplete
                                    ref="staffSel"
                                    v-model="staffSel"
                                    label="ค้นหาบุคลากร"
                                    :items="staffData"
                                    item-text="customDetail"
                                    item-value="perid"
                                    hint="กด Enter เพื่อเป็นการลงทะเบียนเข้าร่วม"
                                    persistent-hint
                                    clearable
                                    outlined
                                    @keyup="checkKeyEnter"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="8"
                                  md="2"
                                  class="d-flex justify-center">
                                <v-btn
                                    v-if="project != null && project.Status_Type_Reg2 == '0'"
                                    outlined
                                    color="primary"
                                    @click="ChooseEmpolyee_s_unlock">
                                  ลงทะเบียน
                                </v-btn>
                                <v-btn
                                    v-else
                                    outlined
                                    color="primary"
                                    @click="ChooseEmpolyee_s">
                                  ลงทะเบียน
                                </v-btn>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-autocomplete
                                    v-model="departSel"
                                    label="เลือกหน่วยงาน"
                                    :items="depart"
                                    item-text="dep_name"
                                    item-value="dep_id"
                                    flat
                                    solo-inverted
                                    hide-details
                                    clearable
                                    clear-icon="mdi-close-circle-outline"
                                    @change="ChooseEmpolyee"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-row v-if="TypeInsert == '2'">
                            <v-col
                                cols="12"
                                md="6">
                              <v-card-text>
                                <v-treeview
                                    :items="items"
                                    selected-color="indigo"
                                    expand-icon="mdi-chevron-down"
                                    off-icon="mdi-checkbox-blank-circle-outline"
                                    on-icon="mdi-checkbox-marked-circle-outline"
                                    indeterminate-icon="mdi-minus-circle-outline"
                                >
                                  <template v-slot:label="{ item }">
                                    <div class="d-flex justify-space-between">
                                    <span
                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                        item.name
                                      }}</span>
                                      <v-switch
                                          inset
                                          :input-value="item.switch"
                                          @change="ChooseEmp(item)"
                                      ></v-switch>
                                    </div>
                                  </template>
                                </v-treeview>
                              </v-card-text>
                            </v-col>

                            <!--                                        <v-divider vertical></v-divider>-->

                            <v-col
                                cols="12"
                                md="6"
                            >
                              <v-card-text>
                                <div
                                    v-if="EmpData.length === 0"
                                    key="title"
                                    class="title font-weight-light grey--text pa-4 text-center"
                                >
                                  <span style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะลงทะเบียนเข้าร่วม</span>
                                </div>

                                <v-scroll-x-transition
                                    group
                                    hide-on-leave
                                >
                                  <v-chip
                                      v-for="(selection, i) in EmpData"
                                      :key="i"
                                      color="grey"
                                      dark
                                      small
                                      class="ma-1"
                                  >
                                    <v-icon left small>mdi-account-circle</v-icon>
                                    {{ selection.name }}
                                  </v-chip>
                                </v-scroll-x-transition>
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-divider v-if="TypeInsert == '2'"></v-divider>
                          <v-card-actions v-if="TypeInsert == '2'">
                            <v-btn
                                text
                                @click="EmpData = []"
                            >
                              Reset
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                                class="white--text"
                                color="green darken-1"
                                depressed
                                @click="SaveToTable"
                            >
                              ลงทะเบียน
                              <v-icon right>mdi-content-save</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <div align="center" style="margin-top: 30px">
                            <v-alert
                                dense
                                outlined
                                type="success"
                                dismissible
                                v-if="ShowAlertSuc"
                            >
                              <div v-html="MessageSuc"></div>
                            </v-alert>
                          </div>
                          <div align="center" style="margin-top: 30px">
                            <v-alert
                                dense
                                outlined
                                type="error"
                                dismissible
                                v-if="ShowAlertErr"
                            >
                              <div v-html="MessageError"></div>
                            </v-alert>
                          </div>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะแพทย์
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="studentData"
                                      item-value="STUDENT_ID"
                                      item-text="fullName"
                                      v-model="Idstudent"
                                      label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"
                                  >
                                  </v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertStd('med')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคลากรคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="AllDepartData"
                                      item-value="FAC_ID"
                                      item-text="FAC_NAME_THAI"
                                      v-model="IdDepart"
                                      label="ค้นหาคณะ/สังกัด"
                                      @change="GetPersonalPSU"
                                  >
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="personalMedData"
                                      item-value="STAFF_ID"
                                      item-text="FULL_NAME"
                                      v-model="IdPersonal"
                                      label="ค้นหา ชื่อ - สกุล รหัสบุคลากร"
                                  >
                                  </v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertPersonUni()">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="AllDepartData"
                                      item-value="FAC_ID"
                                      item-text="FAC_NAME_THAI"
                                      v-model="IdDepartStd"
                                      label="ค้นหาคณะ"
                                      @change="GetStdPSU"
                                  >
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="studentUniData"
                                      item-value="STUDENT_ID"
                                      item-text="fullName"
                                      v-model="IdstudentUni"
                                      label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"
                                  ></v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertStd('other')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคคลภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="8">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="NameP"
                                          label="ชื่อ (name)"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="SurNameP"
                                          label="สกุล (surname)"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="idCard"
                                          label="รหัสบัตรประชาชน"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="affiliation"
                                          label="สังกัด"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="position"
                                          label="ตำแหน่ง"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col
                                      cols="12"
                                      md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item
                                  class="d-flex justify-center"
                              >
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="insertDataPerson('person')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="8">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="NameStd"
                                          label="ชื่อ (name)"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="SurNameStd"
                                          label="สกุล (surname)"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="idCardStd"
                                          label="รหัสบัตรประชาชน"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="affiliationStd"
                                          label="มหาวิทยาลัย"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col
                                      cols="12"
                                      md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item
                                  class="d-flex justify-center"
                              >
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="insertDataPerson('Std')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>


                  <v-card class="mt-7">
                    <v-toolbar
                        :color="appColor"
                        dark
                        flat
                    >
                      <v-toolbar-title>รายชื่อผู้เข้าร่วม ทั้งหมด {{ JoinPerson.length }} คน</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-title>ลงทะเบียน {{ JoinPerson.filter(item => item.status_reg_person == '1').length }} /
                        {{ JoinPerson.length }} คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="searchPerson"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headersPerson"
                        :items="JoinPerson"
                        :search="searchPerson"
                    >
                      <template v-slot:header.action>
                        <template v-if="JoinPerson.length > 0">
                          <div>
                            <v-btn text color="green" @click="registerAll('1')">ยืนยันทั้งหมด</v-btn>
                          </div>
                          <div>
                            <v-btn text color="red" @click="registerAll('0')">ยกเลิกทั้งหมด</v-btn>
                          </div>
                        </template>
                      </template>
                      <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                        <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                      </template>
                      <template v-slot:item.action="{item}">
                        <!--                      <v-btn-->
                        <!--                          color="#F44336"-->
                        <!--                          outlined-->
                        <!--                          @click="Del_item(item)">-->
                        <!--                        ลบ-->
                        <!--                      </v-btn>-->

                        <v-switch
                            class="darken-3"
                            :color="item.status_reg_person == '0' ? 'red' : 'green'"
                            :input-value="item.status_reg_person == '0' ? false : true"
                            @change="ChangeStatusReg(item)"
                        >
                        <span>
                          {{ item.status_reg_person == '0' ? 'รอยืนยันการลงทะเบียน' : 'ยืนยันการลงทะเบียน' }}
                        </span>
                          <template v-slot:label>
                          <span v-if="item.status_reg_person == '1'" style="font-weight: bold;color: darkgreen">
                            ยืนยันเข้าร่วม
                          </span>
                            <span v-else style="font-weight: bold;color: darkred">
                            รอยืนยัน
                          </span>
                          </template>
                        </v-switch>
                      </template>
                    </v-data-table>
                  </v-card>

                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
        <v-snackbar
            v-model="snackbar"
            :color="color"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "RegisterProject",
  data() {
    return {
      FiscalYear: null,
      FiscalYearDataSel: [],
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      color: 'black',
      text: '',
      snackbar: false,
      projectRegDataDump: [],
      Project_code_reg: null,
      dateReg: '',
      dateEndReg: '',
      time_start: '',
      time_end: '',
      round: '',
      round_name: '',
      dialog_create: false,
      dialog_create_confirm: false,
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: null,
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: null,
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      courseHeaders: [
        {text: 'งาน / กิจกรรม', value: 'full_Name'},
/*         {text: 'รอบที่', value: 'round'},
        {text: 'ชื่อรอบ', value: 'round_name'}, */
        {text: 'วันที่เริ่มต้น', value: 'dateReg'},
        {text: 'วันที่สิ้นสุด', value: 'dateEndReg'},
        {text: 'เวลาเริ่ม', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      projectRegData: 'Project/getProjectReg',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      ProjectExport: 'Project/getProjectExport',
      ProjForRegister: 'Project/getAllProjForRegister',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      CardData2: 'Staff/getCard2',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getManageProjectPage',
      RequestProject: 'Project/getRequestProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectRegister: 'Project/initProjectRegister',
      initAllProjectRegister: 'Project/initAllProjectRegister',
      initApproveProjectData: 'Project/initApproveProjectData',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initExportList: 'Project/initExportList',
      initAllProjForRegister: 'Project/initAllProjForRegister',
      initJoinProject: 'Project/initJoinProject',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      getExecCardData: 'Staff/getExecCardData',
      getCardDataMedStudent: 'Staff/getCardDataMedStudent',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeManageProjectPage',
      initRequestProject: 'Project/initRequestProject',
    }),
    init: function () {
      // this.initSockets()
      this.initProjectRoundData().then(res => {
        if (res) {
          this.initProject()
        }
      }).catch(reason => {
        if (reason) {
          this.initProject()
        }
      })
    },
    initProject() {
      this.projectDataToTable = []
      this.projectRegDataDump = []
      // if (this.projectData.length == 0) {
      //   this.initProjectDataForApprove({
      //     query: 'Approve/1/Approve_Treasury/1'
      //   }).then(res => {
      //     if (res) {
      //       if (this.projectForApprove.length > 0) {
      //         this.projectDataToTable = this.projectForApprove.filter(item => item.Status != '2')
      //       }
      //     }
      //   })
      // }


      this.initDepartData()

      this.initPositionsData()

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')'
        })
      }

      this.selProjFiscalYear()
      this.initCardData()

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })

    },
    initSockets() {
      this.sockets.subscribe('connect', (data) => {
        // console.log(data)
        this.text = data.description
        this.color = 'green'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-error', (data) => {
        // console.log(data)
        this.text = 'พบข้อผิดพลาด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-removed', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกถอด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-incorrect', (data) => {
        // console.log(data)
        this.text = 'การอ่านข้อมูลไม่ถูกต้อง โปรดตรวจสอบ การใส่การ์ด หรือ ทำความสะอาดชิปบนการ์ดแล้วลองใหม่อีกครั้ง (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-inserted', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกใส่ (' + data.description + ')'
        this.color = 'black'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-data', (data) => {
        // console.log(data)
        this.text = 'อ่านข้อมูลสำเร็จ'
        this.color = 'green'
        this.snackbar = true
        if (data.status == 200) {
          if (this.Details_Cordi == true) {
            var dataP = this.JoinPerson.filter(item => item.id_card == data.data.cid)
            if (dataP.length > 0) {
              this.ChangeStatusReg(dataP[0])
            } else {
              switch (this.tab) {
                case 4:
                  this.NameP = data.data.name.firstname
                  this.SurNameP = data.data.name.lastname
                  this.idCard = data.data.cid
                  break
                case 5:
                  this.NameStd = data.data.name.firstname
                  this.SurNameStd = data.data.name.lastname
                  this.idCardStd = data.data.cid
                  break
                default:
                  break
              }
            }
          }
        }
      });
    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    CreateProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการสร้างรอบของการลงทะเบียนเข้าร่วมใหม่ ใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          if (this.Project_code_reg == null || this.dateReg == '' || this.dateEndReg == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุข้อมูล ในช่องสีแดงให้ครบถ้วน'
            })
            this.dialogLoading = false
          } else {
            var ProjectData = this.projectDataToTable.filter(item => item.idx == this.Project_code_reg)
            if (ProjectData.length > 0) {
              var url = ''
              if (ProjectData[0].IsRoundStatus == '') {
                url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register_view/Project_code/' + ProjectData[0].Project_code + '/active/1/round/' + this.round
              } else {
                url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register_view/Project_code/' + ProjectData[0].Project_code + '/active/1/D_project_round_id/' + ProjectData[0].Ref_id + '/round/' + this.round
              }
              axios.get(url, '', {
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(res => {
                if (res.data) {
                  this.$swal.fire({
                    timer: 3000,
                    showConfirmButton: false,
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้ เนื่องจาก งาน / กิจกรรม และรอบการจัดดังกล่าวมีในระบบอยู่แล้ว!!'
                  })
                } else {
                  const headerAxios = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register/', {
                    Project_code: ProjectData[0].Project_code,
                    round: this.round,
                    round_name: this.round_name,
                    dateReg: this.dateReg,
                    dateEndReg: this.dateEndReg,
                    time_start: this.time_start,
                    time_end: this.time_end,
                    D_project_round_id: ProjectData[0].id,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, headerAxios).then(res => {
                    if (res.data.status) {
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ!!'
                      })
                      this.Project_code_reg = null
                      this.dateReg = ''
                      this.time_start = ''
                      this.time_end = ''
                      this.round = ''
                      this.round_name = ''
                      this.dialog_create = false
                      this.initAllProjectRegister().then(res => {
                        if (res) {
                          this.initProject()
                          this.dialogLoading = false
                        }
                      }).catch(res => {
                        if (res) {
                          this.initProject()
                          this.dialogLoading = false
                        }
                      })
                    }
                  })
                }
              })
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่พบข้อมูลรหัสแผน โปรดติดต่อ ฝ่ายเทคโนโลยีสารสนเทศ'
              })
            }
          }
        }
      })
    },
    registerAll(status) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการ " + (status == '1' ? 'ยืนยันการลงทะเบียนผู้เข้าร่วมทั้งหมด' : 'ยกเลิกการลงทะเบียนผู้เข้าร่วมทั้งหมด') + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          var count = 0
          this.JoinPerson.map(item => {
            this.updateDataToDB2(item, status).then(res => {
              if (res) {
                item.status_reg_person = status
                count++
                if (count == this.JoinPerson.length) {
                  this.dialogLoading = false
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: status == '1' ? 'ผู้เข้าร่วมทั้งหมดได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!' : 'ผู้เข้าร่วมทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมสำเร็จ!!'
                  })
                }
              }
            })
          })
        }
      })
    },
    ChangeStatusReg(item) {
      this.dialogLoading = true
      var status = (item.status_reg_person == '0') ? '1' : '0'
      this.updateDataToDB2(item, status).then(res => {
        if (res) {
          item.status_reg_person = status
          if (status == '1') {
            this.dialogLoading = false
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'คุณ ' + item.full_Name + ' ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'คุณ ' + item.full_Name + ' ได้ยกเลิกการลงทะเบียนเข้าร่วมสำเร็จ!!'
            })
          }
        }
      })
    },
    insertPersonUni() {
      this.dialogLoading = true
      var CheckDupe = false
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          this.personalMedData.map(value => {
            if (this.IdPersonal == value.STAFF_ID) {
              if (this.JoinPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...value,
                  uid: value.STAFF_ID,
                  full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                  name: value.STAFF_NAME_THAI,
                  sname: value.STAFF_SNAME_THAI,
                  idCard: value.STAFF_PERS_ID,
                  affiliation: value.FAC_NAME_THAI,
                  status_reg_person: '1',
                  position: '',
                  phone: '',
                  registerType_id: 2,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                })
                this.IdPersonal = ''
                this.insertDataToDB(this.project.Ref_id == null ? {
                  Project_code: this.project.Project_code,
                  uid: value.STAFF_ID,
                  name: value.STAFF_NAME_THAI,
                  sname: value.STAFF_SNAME_THAI,
                  id_card: value.STAFF_PERS_ID,
                  affiliation: value.FAC_NAME_THAI,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 2,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                } : {
                  Project_code: this.project.Project_code,
                  uid: value.STAFF_ID,
                  name: value.STAFF_NAME_THAI,
                  sname: value.STAFF_SNAME_THAI,
                  id_card: value.STAFF_PERS_ID,
                  affiliation: value.FAC_NAME_THAI,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 2,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res) {
                    this.updateDataToDB({
                      Project_code: this.project.Project_code,
                      uid: value.STAFF_ID,
                      name: value.STAFF_NAME_THAI,
                      sname: value.STAFF_SNAME_THAI,
                      id_card: value.STAFF_PERS_ID,
                      affiliation: value.FAC_NAME_THAI,
                      status_reg_person: '1',
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      position: '',
                      phone: '',
                      registerType_id: 2,
                    }).then(res => {
                      if (res) {
                        this.dialogLoading = false
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้'
                    })
                  }
                })
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          })
        } else { 
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    insertStd(msg) {
      return new Promise(resolve => {
        this.dialogLoading = true
        var CheckDupe = false
        this.CheckPermissFunc('7001').then(resPermiss => {
          if (resPermiss) {
            if (msg == 'med') {
              if (this.Idstudent != null) {
                if (this.studentData.filter(stdI => stdI.STUDENT_ID == this.Idstudent).length > 0) {
                  this.studentData.map(value => {
                    if (this.Idstudent == value.STUDENT_ID) {
                      if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.JoinPerson.unshift({
                          ...value,
                          uid: value.STUDENT_ID,
                          full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                          name: value.STUD_NAME_THAI,
                          sname: value.STUD_SNAME_THAI,
                          idCard: value.CITIZEN_ID,
                          affiliation: 'คณะแพทยศาสตร์',
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          registerType_id: 1,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        })
                        this.Idstudent = null
                        this.insertDataToDB(this.project.Ref_id == null ? {
                          Project_code: this.project.Project_code,
                          uid: value.STUDENT_ID,
                          name: value.STUD_NAME_THAI,
                          sname: value.STUD_SNAME_THAI,
                          id_card: value.CITIZEN_ID,
                          affiliation: 'คณะแพทยศาสตร์',
                          position: '',
                          phone: '',
                          join_status: '1',
                          extra_type: '0',
                          registerType_id: 1,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        } : {
                          Project_code: this.project.Project_code,
                          uid: value.STUDENT_ID,
                          name: value.STUD_NAME_THAI,
                          sname: value.STUD_SNAME_THAI,
                          id_card: value.CITIZEN_ID,
                          affiliation: 'คณะแพทยศาสตร์',
                          position: '',
                          phone: '',
                          join_status: '1',
                          extra_type: '0',
                          registerType_id: 1,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res) {
                            this.updateDataToDB({
                              Project_code: this.project.Project_code,
                              uid: value.STUDENT_ID,
                              name: value.STUD_NAME_THAI,
                              sname: value.STUD_SNAME_THAI,
                              id_card: value.CITIZEN_ID,
                              affiliation: 'คณะแพทยศาสตร์',
                              status_reg_person: '1',
                              position: '',
                              phone: '',
                              registerType_id: 1,
                              ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                            }).then(res => {
                              if (res) {
                                this.dialogLoading = false
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                                })
                              } else {
                                this.dialogLoading = false
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                              resolve(true)
                            })
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                            resolve(true)
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                        resolve(true)
                      }
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูล นักศึกษาโปรดตรวจสอบบัตรและข้อมูลนักศึกษาอีกครั้ง!',
                  })
                  this.dialogLoading = false
                  // this.$refs.Idstudent.$refs.input.focus()
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดระบุนักศึกษาก่อนทำรายการ!',
                })
                this.dialogLoading = false
                // this.$refs.Idstudent.$refs.input.focus()
              }
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      status_reg_person: '1',
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB(this.project.Ref_id == null ? {
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    } : {
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 3,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res) {
                        this.updateDataToDB({
                          Project_code: this.project.Project_code,
                          uid: value.STUDENT_ID,
                          name: value.STUD_NAME_THAI,
                          sname: value.STUD_SNAME_THAI,
                          id_card: value.CITIZEN_ID,
                          affiliation: 'คณะแพทยศาสตร์',
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          join_status: '1',
                          registerType_id: 3,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        }).then(res => {
                          if (res) {
                            this.dialogLoading = false
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                            })
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                          resolve(true)
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                        resolve(true)
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                    resolve(true)
                  }
                }
              })
            }
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
            })
            resolve(true)
          }
        })
      })
    },
    Del_item(item) {
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.JoinPerson = this.JoinPerson.filter(value => value.uid != item.uid)
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                // 'X-REST-METHOD': 'DELETE'
              }
            }
            if (this.JoinPerson.length > 0) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/id/' + item.id, {
                active: '0',
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'ลบข้อมูลผู้เข้าร่วม ' + item.full_Name + ' สำเร็จ!!'
                  })
                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.JoinPerson = this.JoinPerson.filter(value => value.uid != item.uid)
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                // 'X-REST-METHOD': 'DELETE'
              }
            }
            if (this.JoinPerson.length > 0) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/id/' + item.id, {
                active: '0',
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'ลบข้อมูลผู้เข้าร่วม ' + item.full_Name + ' สำเร็จ!!'
                  })
                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        if (this.project != null && this.Status_Type_Reg2 == '0') {
          this.ChooseEmpolyee_s_unlock()
        } else if (this.project != null && this.Status_Type_Reg2 == '1') {
          this.ChooseEmpolyee_s()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'กรุณาตรวจสอบข้อมูลที่กรอกให้ถูกต้อง'
          })
        }
      }
    },
    // ก่อนปลด
    ChooseEmpolyee_c(event) {
      var GetData = []
      var CheckDupe = false
      var checkPermiss = false
      var dumpData = null
      if (this.PermissionAdmin.length > 0) {
        if (event.key == "Enter") {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == parseInt(this.cardSel))
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  dumpData = this.JoinPerson.filter(item => item.uid == GetData[0].PERID)
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.dialogLoading = false
                  this.cardSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                  })
                 /* this.dialogLoading = true
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    status_reg_person: '1',
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  })
                  this.cardSel = ''
                  this.insertDataToDB(this.project.Ref_id == null ? {
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    join_status: '1',
                    extra_type: '0',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  } : {
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    join_status: '1',
                    extra_type: '0',
                    registerType_id: 0,
                    ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }).then(res => {
                    if (res) {
                      this.updateDataToDB({
                        ...GetData[0],
                        uid: GetData[0].perid,
                        name: GetData[0].name,
                        sname: GetData[0].surname,
                        idCard: GetData[0].citizen_id,
                        affiliation: GetData[0].dep_name,
                        status_reg_person: '1',
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      }).then(res => {
                        if (res) {
                          this.cardSel = ''
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                          })
                          this.dialogLoading = false
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })*/
                } else {
                  // this.requestRegChecking(this.project,GetData[0].perid).then(res => {
                  //   if (res) {
                  //     this.dialogLoading = false
                  //     this.$swal.fire({
                  //       icon: 'error',
                  //       title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากพบข้อมูลรายชื่อไม่ได้รับการอนุมัติให้เข้าร่วมงาน !!'
                  //     })
                  //   } else {
                      this.dialogLoading = true
                      this.updateDataToDB(dumpData[0]).then(res => {
                        if (res) {
                          this.cardSel = ''
                          this.JoinPerson.map(Join_i => {
                            if (Join_i.uid == GetData[0].perid) {
                              Join_i.status_reg_person = '1'
                            }
                          })
                          this.dialogLoading = false
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                  //   }
                  // })
                }
              } else {
                this.getCardDataMedStudent({
                  card_no: this.cardSel
                }).then(res => {
                  if (res) {
                    if (this.CardData2.length > 0) {
                      this.Idstudent = this.CardData2[0].uid
                      this.cardSel = ''
                      this.insertStd('med')
                    } else {
                      this.dialogLoading = false
                      this.cardSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลหมายเลข !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        this.$refs.cardSel.$refs.input.focus()
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.cardSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      this.$refs.cardSel.$refs.input.focus()
                    }, 1000)
                  }
                })
              }
            } else {
              if (!checkPermiss && idx == this.PermissionAdmin.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      } else {
        if (event.key == "Enter") {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == parseInt(this.cardSel))
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  dumpData = this.JoinPerson.filter(item => item.uid == GetData[0].PERID)
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.dialogLoading = false
                  this.cardSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                  })
                 /* GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    status_reg_person: '1',
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  })
                  this.cardSel = ''
                  this.insertDataToDB(this.project.Ref_id == null ? {
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    join_status: '1',
                    extra_type: '0',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  } : {
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    join_status: '1',
                    extra_type: '0',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }).then(res => {
                    if (res) {
                      this.updateDataToDB({
                        ...GetData[0],
                        uid: GetData[0].perid,
                        name: GetData[0].name,
                        sname: GetData[0].surname,
                        idCard: GetData[0].citizen_id,
                        affiliation: GetData[0].dep_name,
                        status_reg_person: '1',
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      }).then(res => {
                        if (res) {
                          this.dialogLoading = false
                          this.cardSel = ''
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })*/
                } else {
                  this.updateDataToDB(dumpData[0]).then(res => {
                    if (res) {
                      this.cardSel = ''
                      this.JoinPerson.map(Join_i => {
                        if (Join_i.uid == GetData[0].perid) {
                          Join_i.status_reg_person = '1'
                        }
                      })
                      this.dialogLoading = false
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })
                }
              } else {
                this.dialogLoading = false
                this.cardSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลบัตรบุคลากร โปรดติดต่อ ฝ่าย IT'
                })
              }
            } else {
              if (!checkPermiss && idx == this.Permission.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      }
    },
    // ปลดไม่ล็อคคน
    ChooseEmpolyee_c_unlock(event) {
      var GetData = []
      var CheckDupe = false
      var checkPermiss = false
      var dumpData = null
      var checkCondi = true

      if (this.PermissionAdmin.length > 0) {
        if (event.key == "Enter") {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == parseInt(this.cardSel))
              if (GetData.length > 0) {
                GetData = this.UniqueArraybyId(GetData, 'PERID')
                if (GetData.length == 1) {
                  if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                    dumpData = this.JoinPerson.filter(item => item.uid == GetData[0].PERID)
                    GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    /*this.dialogLoading = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                  })*/

                    if (this.project.Status_Count_Reg == '1') {
                      checkCondi = true
                    } else if(this.project.Status_Count_Reg == '0' && this.JoinPerson.length > parseInt(this.project.Count_Reg)) {
                      checkCondi = false
                    }
                    if (checkCondi) {
                      this.dialogLoading = true
                      GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                      this.JoinPerson.unshift({
                        ...GetData[0],
                        uid: GetData[0].perid,
                        name: GetData[0].name,
                        sname: GetData[0].surname,
                        idCard: GetData[0].citizen_id,
                        affiliation: GetData[0].dep_name,
                        status_reg_person: '1',
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      })
                      this.cardSel = ''
                      this.insertDataToDB(this.project.Ref_id == null ? {
                        Project_code: this.project.Project_code,
                        uid: GetData[0].perid,
                        name: GetData[0].name,
                        sname: GetData[0].surname,
                        id_card: GetData[0].citizen_id,
                        affiliation: GetData[0].dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      } : {
                        Project_code: this.project.Project_code,
                        uid: GetData[0].perid,
                        name: GetData[0].name,
                        sname: GetData[0].surname,
                        id_card: GetData[0].citizen_id,
                        affiliation: GetData[0].dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res) {
                          this.updateDataToDB({
                            ...GetData[0],
                            uid: GetData[0].perid,
                            name: GetData[0].name,
                            sname: GetData[0].surname,
                            idCard: GetData[0].citizen_id,
                            affiliation: GetData[0].dep_name,
                            status_reg_person: '1',
                            position: '',
                            phone: '',
                            registerType_id: 0,
                            ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                          }).then(res => {
                            if (res) {
                              this.cardSel = ''
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                              })
                              setTimeout(() => {
                                this.$refs.cardSel.$refs.input.focus()
                              }, 1000)
                              this.dialogLoading = false
                            } else {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้'
                              })
                              setTimeout(() => {
                                this.$refs.cardSel.$refs.input.focus()
                              }, 1000)
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                          setTimeout(() => {
                            this.$refs.cardSel.$refs.input.focus()
                          }, 1000)
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากขณะนี้พบผู้เข้าร่วมเต็มจำนวนแล้ว !!'
                      })
                    }
                  } else {
                    // this.requestRegChecking(this.project,GetData[0].perid).then(res => {
                    //   if (res) {
                    //     this.dialogLoading = false
                    //     this.$swal.fire({
                    //       icon: 'error',
                    //       title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากพบข้อมูลรายชื่อไม่ได้รับการอนุมัติให้เข้าร่วมงาน !!'
                    //     })
                    //   } else {
                    if (this.JoinPerson.filter(jItem => jItem.uid == GetData[0].perid && jItem.status_reg_person == '1').length > 0) {
                      this.cardSel = ''
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'warning',
                        title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') พบข้อมูลการลงทะเบียนเข้าร่วมโครงการแล้ว!!'
                      })
                      setTimeout(() => {
                        this.$refs.cardSel.$refs.input.focus()
                      }, 1000)
                    } else {
                      this.dialogLoading = true
                      this.updateDataToDB(dumpData[0]).then(res => {
                        if (res) {
                          this.cardSel = ''
                          this.JoinPerson.map(Join_i => {
                            if (Join_i.uid == GetData[0].perid) {
                              Join_i.status_reg_person = '1'
                            }
                          })
                          this.dialogLoading = false
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                          })
                          setTimeout(() => {
                            this.$refs.cardSel.$refs.input.focus()
                          }, 1000)
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                          setTimeout(() => {
                            this.$refs.cardSel.$refs.input.focus()
                          }, 1000)
                        }
                      })
                    }

                    //   }
                    // })
                  }
                } else {
                  this.dialogLoading = false
                  this.cardSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                  })
                  setTimeout(() => {
                    this.$refs.cardSel.$refs.input.focus()
                  }, 1000)
                }
              } else {
                this.getCardDataMedStudent({
                  card_no: this.cardSel
                }).then(res => {
                  if (res) {
                    if (this.CardData2.length > 0) {
                      this.Idstudent = this.CardData2[0].uid
                      this.cardSel = ''
                      this.insertStd('med')
                    } else {
                      this.dialogLoading = false
                      this.cardSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลหมายเลข !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        this.$refs.cardSel.$refs.input.focus()
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.cardSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      this.$refs.cardSel.$refs.input.focus()
                    }, 1000)
                  }
                })
              }
            } else {
              if (!checkPermiss && idx == this.PermissionAdmin.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
                setTimeout(() => {
                  this.$refs.cardSel.$refs.input.focus()
                }, 1000)
              }
            }
          })
        }
      } else {
        if (event.key == "Enter") {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == parseInt(this.cardSel))
              if (GetData.length > 0) {
                GetData = this.UniqueArraybyId(GetData, 'PERID')
                if (GetData.length == 1) {
                  if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                    dumpData = this.JoinPerson.filter(item => item.uid == GetData[0].PERID)
                    GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    if (this.project.Status_Count_Reg == '1') {
                      checkCondi = true
                    } else if(this.project.Status_Count_Reg == '0' && this.JoinPerson.length > parseInt(this.project.Count_Reg)) {
                      checkCondi = false
                    }
                    if (checkCondi) {
                      this.dialogLoading = true
                    GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                    this.JoinPerson.unshift({
                      ...GetData[0],
                      uid: GetData[0].perid,
                      name: GetData[0].name,
                      sname: GetData[0].surname,
                      idCard: GetData[0].citizen_id,
                      affiliation: GetData[0].dep_name,
                      status_reg_person: '1',
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    })
                    this.cardSel = ''
                    this.insertDataToDB(this.project.Ref_id == null ? {
                      Project_code: this.project.Project_code,
                      uid: GetData[0].perid,
                      name: GetData[0].name,
                      sname: GetData[0].surname,
                      id_card: GetData[0].citizen_id,
                      affiliation: GetData[0].dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    } : {
                      Project_code: this.project.Project_code,
                      uid: GetData[0].perid,
                      name: GetData[0].name,
                      sname: GetData[0].surname,
                      id_card: GetData[0].citizen_id,
                      affiliation: GetData[0].dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res) {
                        this.updateDataToDB({
                          ...GetData[0],
                          uid: GetData[0].perid,
                          name: GetData[0].name,
                          sname: GetData[0].surname,
                          idCard: GetData[0].citizen_id,
                          affiliation: GetData[0].dep_name,
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          registerType_id: 0,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        }).then(res => {
                          if (res) {
                            this.dialogLoading = false
                            this.cardSel = ''
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                            })
                            setTimeout(() => {
                              this.$refs.cardSel.$refs.input.focus()
                            }, 1000)
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                            setTimeout(() => {
                              this.$refs.cardSel.$refs.input.focus()
                            }, 1000)
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                        setTimeout(() => {
                          this.$refs.cardSel.$refs.input.focus()
                        }, 1000)
                      }
                    })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากขณะนี้พบผู้เข้าร่วมเต็มจำนวนแล้ว !!'
                      })
                    }
                  } else {
                    if (this.JoinPerson.filter(jItem => jItem.uid == GetData[0].perid && jItem.status_reg_person == '1').length > 0) {
                      this.cardSel = ''
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'warning',
                        title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') พบข้อมูลการลงทะเบียนเข้าร่วมโครงการแล้ว!!'
                      })
                      setTimeout(() => {
                        this.$refs.cardSel.$refs.input.focus()
                      }, 1000)
                    } else {
                      this.dialogLoading = true
                      this.updateDataToDB(dumpData[0]).then(res => {
                        if (res) {
                          this.cardSel = ''
                          this.JoinPerson.map(Join_i => {
                            if (Join_i.uid == GetData[0].perid) {
                              Join_i.status_reg_person = '1'
                            }
                          })
                          this.dialogLoading = false
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'คุณ : ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                          })
                          setTimeout(() => {
                            this.$refs.cardSel.$refs.input.focus()
                          }, 1000)
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                          setTimeout(() => {
                            this.$refs.cardSel.$refs.input.focus()
                          }, 1000)
                        }
                      })
                    }
                  }
                } else {
                  this.dialogLoading = false
                  this.cardSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                  })
                  setTimeout(() => {
                    this.$refs.cardSel.$refs.input.focus()
                  }, 1000)
                }
              } else {
                this.getCardDataMedStudent({
                  card_no: this.cardSel
                }).then(res => {
                  if (res) {
                    if (this.CardData2.length > 0) {
                      this.Idstudent = this.CardData2[0].uid
                      this.cardSel = ''
                      this.insertStd('med')
                    } else {
                      this.dialogLoading = false
                      this.cardSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลหมายเลข !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        this.$refs.cardSel.$refs.input.focus()
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.cardSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      this.$refs.cardSel.$refs.input.focus()
                    }, 1000)
                  }
                })
              }
            } else {
              if (!checkPermiss && idx == this.Permission.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
                setTimeout(() => {
                  this.$refs.cardSel.$refs.input.focus()
                }, 1000)
              }
            }
          })
        }
      }
    },
    // CheckEmpApprove() {
    //   return new Promise(resolve => {
    //
    //   })
    // },
    // ก่อนปลด
    ChooseEmpolyee_s() {
      this.dialogLoading = true
      var CheckDupe = false
      var CheckPermiss = false
      var dumpData = null
      if (this.staffSel == null) {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลบุคลากร!'
        })
        this.dialogLoading = false
      } else {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              CheckPermiss = true
              if (this.staffData.length > 0) {
                this.staffData.map((staff_I) => {
                  if (staff_I.perid == this.staffSel) {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      dumpData = this.JoinPerson.filter(item => item.uid == this.staffSel)
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.dialogLoading = false
                      this.staffSel = null
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                      })
                      /*this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg_person: '1',
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      })
                      this.insertDataToDB(this.project.Ref_id == null ? {
                        Project_code: this.project.Project_code,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        id_card: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      } : {
                        Project_code: this.project.Project_code,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        id_card: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res) {
                          this.updateDataToDB({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg_person: '1',
                            position: '',
                            phone: '',
                            registerType_id: 0,
                            ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                          }).then(res => {
                            if (res) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูล ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') สำเร็จ!!'
                              })
                            } else {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })*/
                    } else {
                      this.updateDataToDB(dumpData[0]).then(res => {
                        if (res) {
                          this.staffSel = null
                          this.JoinPerson.map(Join_i => {
                            if (Join_i.uid == staff_I.perid) {
                              Join_i.status_reg_person = '1'
                            }
                          })
                          this.dialogLoading = false
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย ไม่สามารถบันทึกข้อมูลได้สำเร็จ โปรดลองทำรายการอีกครั้ง'
                })
              }
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              CheckPermiss = true
              this.staffData.map((staff_I) => {
                if (staff_I.perid == this.staffSel) {
                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                    dumpData = this.JoinPerson.filter(item => item.uid == this.staffSel)
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.dialogLoading = false
                    this.staffSel = null
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                    })
                    /*this.JoinPerson.unshift({
                      ...staff_I,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_reg_person: '1',
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    })
                    this.insertDataToDB(this.project.Ref_id == null ? {
                      Project_code: this.project.Project_code,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      id_card: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    } : {
                      Project_code: this.project.Project_code,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      id_card: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res) {
                        this.updateDataToDB({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          registerType_id: 0,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        }).then(res => {
                          if (res) {
                            this.dialogLoading = false
                            this.staffSel = null
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูล ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') สำเร็จ!!'
                            })
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                      }
                    })*/
                  } else {
                    this.updateDataToDB(dumpData[0]).then(res => {
                      if (res) {
                        this.staffSel = null
                        this.JoinPerson.map(Join_i => {
                          if (Join_i.uid == staff_I.perid) {
                            Join_i.status_reg_person = '1'
                          }
                        })
                        this.dialogLoading = false
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                      }
                    })
                  }
                }
              })
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      }
    },
    ChooseEmpolyee_s_unlock() {
      this.dialogLoading = true
      var CheckDupe = false
      var CheckPermiss = false
      var dumpData = null
      var checkCondi = true
      if (this.staffSel == null) {
        this.$swal.fire({
          timer: 1500,
          showConfirmButton: false,
          icon: 'error',
          title: 'กรุณาระบุข้อมูลบุคลากร!'
        })
        this.dialogLoading = false
      } else {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              CheckPermiss = true
              if (this.staffData.length > 0) {
                this.staffData.map((staff_I) => {
                  if (staff_I.perid == this.staffSel) {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      dumpData = this.JoinPerson.filter(item => item.uid == this.staffSel)
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      /*this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากไม่พบข้อมูลอยู่ในรายชื่อผู้เข้าร่วม !!'
                      })*/
                      if (this.project.Status_Count_Reg == '1') {
                        checkCondi = true
                      } else if(this.project.Status_Count_Reg == '0' && this.JoinPerson.length > parseInt(this.project.Count_Reg)) {
                        checkCondi = false
                      }
                      if (checkCondi) {
                        this.dialogLoading = true
                        this.JoinPerson.unshift({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          registerType_id: 0,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        })
                        this.insertDataToDB(this.project.Ref_id == null ? {
                        Project_code: this.project.Project_code,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        id_card: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      } : {
                        Project_code: this.project.Project_code,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        id_card: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        position: '',
                        phone: '',
                        join_status: '1',
                        extra_type: '0',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res) {
                          this.updateDataToDB({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg_person: '1',
                            position: '',
                            phone: '',
                            registerType_id: 0,
                            ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                          }).then(res => {
                            if (res) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูล ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') สำเร็จ!!'
                              })
                              setTimeout(() => {
                                this.$refs.staffSel.$refs.input.focus()
                              }, 1000)
                            } else {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้'
                              })
                              setTimeout(() => {
                                this.$refs.staffSel.$refs.input.focus()
                              }, 1000)
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                          setTimeout(() => {
                            this.$refs.staffSel.$refs.input.focus()
                          }, 1000)
                        }
                      })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากขณะนี้พบผู้เข้าร่วมเต็มจำนวนแล้ว !!'
                        })
                      }
                    } else {
                      if (this.JoinPerson.filter(jItem => jItem.uid == staff_I.perid && jItem.status_reg_person == '1').length > 0) {
                        this.staffSel = null
                        this.dialogLoading = false
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'warning',
                          title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') พบข้อมูลการลงทะเบียนเข้าร่วมโครงการแล้ว!!'
                        })
                        setTimeout(() => {
                          this.$refs.staffSel.$refs.input.focus()
                        }, 1000)
                      } else {
                        this.updateDataToDB(dumpData[0]).then(res => {
                          if (res) {
                            this.staffSel = null
                            this.JoinPerson.map(Join_i => {
                              if (Join_i.uid == staff_I.perid) {
                                Join_i.status_reg_person = '1'
                              }
                            })
                            this.dialogLoading = false
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                            })
                            setTimeout(() => {
                              this.$refs.staffSel.$refs.input.focus()
                            }, 1000)
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                            setTimeout(() => {
                              this.$refs.staffSel.$refs.input.focus()
                            }, 1000)
                          }
                        })
                      }
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย ไม่สามารถบันทึกข้อมูลได้สำเร็จ โปรดลองทำรายการอีกครั้ง'
                })
                setTimeout(() => {
                  this.$refs.staffSel.$refs.input.focus()
                }, 1000)
              }
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
                setTimeout(() => {
                  this.$refs.staffSel.$refs.input.focus()
                }, 1000)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              CheckPermiss = true
              this.staffData.map((staff_I) => {
                if (staff_I.perid == this.staffSel) {
                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                    dumpData = this.JoinPerson.filter(item => item.uid == this.staffSel)
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    if (this.project.Status_Count_Reg == '1') {
                      checkCondi = true
                    } else if(this.project.Status_Count_Reg == '0' && this.JoinPerson.length > parseInt(this.project.Count_Reg)) {
                      checkCondi = false
                    }
                    if (checkCondi) {
                      this.dialogLoading = true
                      this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg_person: '1',
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      })
                      this.insertDataToDB(this.project.Ref_id == null ? {
                      Project_code: this.project.Project_code,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      id_card: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    } : {
                      Project_code: this.project.Project_code,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      id_card: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      join_status: '1',
                      extra_type: '0',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res) {
                        this.updateDataToDB({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg_person: '1',
                          position: '',
                          phone: '',
                          registerType_id: 0,
                          ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                        }).then(res => {
                          if (res) {
                            this.dialogLoading = false
                            this.staffSel = null
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูล ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') สำเร็จ!!'
                            })
                            setTimeout(() => {
                              this.$refs.staffSel.$refs.input.focus()
                            }, 1000)
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้'
                            })
                            setTimeout(() => {
                              this.$refs.staffSel.$refs.input.focus()
                            }, 1000)
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้'
                        })
                        setTimeout(() => {
                          this.$refs.staffSel.$refs.input.focus()
                        }, 1000)
                      }
                    })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนเข้าร่วมงานได้สำเร็จ เนื่องจากขณะนี้พบผู้เข้าร่วมเต็มจำนวนแล้ว !!'
                      })
                    }
                  } else {
                    if (this.JoinPerson.filter(jItem => jItem.uid == staff_I.perid && jItem.status_reg_person == '1').length > 0) {
                      this.staffSel = null
                      this.dialogLoading = false
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'warning',
                        title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') พบข้อมูลการลงทะเบียนเข้าร่วมโครงการแล้ว!!'
                      })
                      setTimeout(() => {
                        this.$refs.staffSel.$refs.input.focus()
                      }, 1000)
                    } else {
                      this.updateDataToDB(dumpData[0]).then(res => {
                        if (res) {
                          this.staffSel = null
                          this.JoinPerson.map(Join_i => {
                            if (Join_i.uid == staff_I.perid) {
                              Join_i.status_reg_person = '1'
                            }
                          })
                          this.dialogLoading = false
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'คุณ : ' + staff_I.full_Name + ' รหัส (' + staff_I.perid + ') ได้ทำการลงทะเบียนเข้าร่วมสำเร็จ!!'
                          })
                          setTimeout(() => {
                            this.$refs.staffSel.$refs.input.focus()
                          }, 1000)
                        } else {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้'
                          })
                          setTimeout(() => {
                            this.$refs.staffSel.$refs.input.focus()
                          }, 1000)
                        }
                      })
                    }
                  }
                }
              })
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
                setTimeout(() => {
                  this.$refs.staffSel.$refs.input.focus()
                }, 1000)
              }
            }
          })
        }
      }
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      this.dialogLoading = true
      var CheckDupe = false
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          if (type == 'person') {
            if (this.JoinPerson.filter(item => item.uid == ('P_' + this.JoinPerson.length)).length > 0) {
              CheckDupe = true
            }
            if (!CheckDupe) {
              this.JoinPerson.unshift({
                uid: 'P_' + this.JoinPerson.length,
                full_Name: this.NameP + ' ' + this.SurNameP,
                name: this.NameP,
                sname: this.SurNameP,
                idCard: this.idCard,
                affiliation: this.affiliation,
                status_reg_person: '1',
                position: this.position,
                phone: this.phoneOther,
                registerType_id: 4,
                ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
              })
              this.insertDataToDB(this.project.Ref_id == null ? {
                Project_code: this.project.Project_code,
                uid: 'P_' + this.JoinPerson.length,
                name: this.NameP,
                sname: this.SurNameP,
                id_card: this.idCard,
                affiliation: this.affiliation,
                position: this.position,
                phone: this.phoneOther,
                join_status: '1',
                extra_type: '0',
                registerType_id: 4,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              } : {
                Project_code: this.project.Project_code,
                uid: 'P_' + this.JoinPerson.length,
                name: this.NameP,
                sname: this.SurNameP,
                id_card: this.idCard,
                affiliation: this.affiliation,
                position: this.position,
                phone: this.phoneOther,
                join_status: '1',
                extra_type: '0',
                registerType_id: 4,
                ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }).then(res => {
                if (res) {
                  this.updateDataToDB({
                    Project_code: this.project.Project_code,
                    uid: 'P_' + this.JoinPerson.length,
                    name: this.NameP,
                    sname: this.SurNameP,
                    id_card: this.idCard,
                    affiliation: this.affiliation,
                    status_reg_person: '1',
                    position: this.position,
                    phone: this.phoneOther,
                    registerType_id: 4,
                    ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  }).then(res => {
                    if (res) {
                      this.dialogLoading = false
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้'
                  })
                }
              })
              this.NameP = ''
              this.SurNameP = ''
              this.idCard = ''
              this.affiliation = ''
              this.position = ''
              this.phoneOther = ''
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
              })
            }
          } else {
            if (this.JoinPerson.filter(item => item.uid == ('S_' + this.JoinPerson.length)).length > 0) {
              CheckDupe = true
            }
            if (!CheckDupe) {
              this.JoinPerson.unshift({
                uid: 'S_' + this.JoinPerson.length,
                full_Name: this.NameStd + ' ' + this.SurNameStd,
                name: this.NameStd,
                sname: this.SurNameStd,
                idCard: this.idCardStd,
                affiliation: this.affiliationStd,
                status_reg_person: '1',
                position: '',
                phone: this.phoneOther,
                registerType_id: 5,
                ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
              })
              this.insertDataToDB(this.project.Ref_id == null ? {
                Project_code: this.project.Project_code,
                uid: 'S_' + this.JoinPerson.length,
                name: this.NameStd,
                sname: this.SurNameStd,
                id_card: this.idCardStd,
                affiliation: this.affiliationStd,
                position: '',
                phone: this.phoneOther,
                join_status: '1',
                extra_type: '0',
                registerType_id: 5,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              } : {
                Project_code: this.project.Project_code,
                uid: 'S_' + this.JoinPerson.length,
                name: this.NameStd,
                sname: this.SurNameStd,
                id_card: this.idCardStd,
                affiliation: this.affiliationStd,
                position: '',
                phone: this.phoneOther,
                join_status: '1',
                extra_type: '0',
                registerType_id: 5,
                ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }).then(res => {
                if (res) {
                  this.updateDataToDB({
                    Project_code: this.project.Project_code,
                    uid: 'P_' + this.JoinPerson.length,
                    name: this.NameP,
                    sname: this.SurNameP,
                    id_card: this.idCard,
                    affiliation: this.affiliation,
                    status_reg_person: '1',
                    position: this.position,
                    phone: this.phoneOther,
                    registerType_id: 5,
                    ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  }).then(res => {
                    if (res) {
                      this.dialogLoading = false
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                      })
                    } else {
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้'
                  })
                }
              })
              this.NameStd = ''
              this.SurNameStd = ''
              this.idCardStd = ''
              this.affiliationStd = ''
              this.phoneOther = ''
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
              })
            }

          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    SaveToTable() {
      this.dialogLoading = true
      var CheckDupe = false
      var CheckPermiss = false
      this.MessageError = ''
      this.MessageSuc = ''
      var dumpData = null

      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.EmpData.map((item) => {
              CheckDupe = false
              dumpData = null
              if (this.JoinPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
                dumpData = this.JoinPerson.filter(Join_I => Join_I.uid == item.perid)
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.dialogLoading = false
                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่พบข้อมูลรายชื่อผู้เข้าร่วม !!</p>'
                this.ShowAlertErr = true
                /*this.JoinPerson.unshift({
                  ...item,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  idCard: item.citizen_id,
                  affiliation: item.dep_name,
                  status_reg_person: '1',
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                })

                this.insertDataToDB(this.project.Ref_id == null ? {
                  Project_code: this.project.Project_code,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 0,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                } : {
                  Project_code: this.project.Project_code,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 0,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res) {
                    this.updateDataToDB({
                      ...item,
                      uid: item.perid,
                      name: item.name,
                      sname: item.surname,
                      idCard: item.citizen_id,
                      affiliation: item.dep_name,
                      status_reg_person: '1',
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    }).then(res => {
                      if (res) {
                        this.dialogLoading = false
                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                        this.ShowAlertSuc = true
                      } else {
                        this.dialogLoading = false
                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                        this.ShowAlertErr = true
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                    this.ShowAlertErr = true
                  }
                })*/
              } else {
                this.updateDataToDB(dumpData[0]).then(res => {
                  if (res) {
                    this.JoinPerson.map(Join_i => {
                      if (Join_i.uid == item.perid) {
                        Join_i.status_reg_person = '1'
                      }
                    })
                    this.dialogLoading = false
                    this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' ลงทะเบียนสำเร็จ !!</p>'
                    this.ShowAlertSuc = true
                  } else {
                    this.dialogLoading = false
                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                    this.ShowAlertErr = true
                  }
                })
              }
            })
            this.EmpData = []
            this.items = []
            this.departSel = ''
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.EmpData.map((item) => {
              CheckDupe = false
              if (this.JoinPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
                dumpData = this.JoinPerson.filter(Join_I => Join_I.uid == item.perid)
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...item,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  idCard: item.citizen_id,
                  affiliation: item.dep_name,
                  status_reg_person: '1',
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                })

                this.insertDataToDB(this.project.Ref_id == null ? {
                  Project_code: this.project.Project_code,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 0,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                } : {
                  Project_code: this.project.Project_code,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  join_status: '1',
                  extra_type: '0',
                  registerType_id: 0,
                  ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res) {
                    this.updateDataToDB({
                      ...item,
                      uid: item.perid,
                      name: item.name,
                      sname: item.surname,
                      idCard: item.citizen_id,
                      affiliation: item.dep_name,
                      status_reg_person: '1',
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      ...(this.project.IsRoundStatus == '1' && { D_project_round_id: this.project.Ref_id }),
                    }).then(res => {
                      if (res) {
                        this.dialogLoading = false
                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                        this.ShowAlertSuc = true
                      } else {
                        this.dialogLoading = false
                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                        this.ShowAlertErr = true
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                    this.ShowAlertErr = true
                  }
                })
              } else {
                this.updateDataToDB(dumpData[0]).then(res => {
                  if (res) {
                    this.JoinPerson.map(Join_i => {
                      if (Join_i.uid == item.perid) {
                        Join_i.status_reg_person = '1'
                      }
                    })
                    this.dialogLoading = false
                    this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' ลงทะเบียนสำเร็จ !!</p>'
                    this.ShowAlertSuc = true
                  } else {
                    this.dialogLoading = false
                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                    this.ShowAlertErr = true
                  }
                })
              }
            })
            this.EmpData = []
            this.items = []
            this.departSel = ''
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    DelRoundProject(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบรอบของการลงทะเบียนเข้าร่วม" + item.Project_name + (item.round != '' ? " รอบที่ " + item.round : '') + " ใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              // 'X-REST-METHOD': 'DELETE'
            }
          }
          var url = ''
          url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register/id/' + item.D_Project_Register_id
          axios.post(url, {
            active: '0',
            update_by: this.MeData[0].perid
          }, headerAxios).then(res => {
            if (res.data.status) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + item.D_Project_Register_id, {
                active: '0',
                Update_By: this.MeData[0].perid
              }, headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/D_Project_Register_id/' + item.D_Project_Register_id, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, headerAxios)
              this.$swal.fire({
                timer: 1500,
                showConfirmButton: false,
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ!!'
              })
              this.initAllProjectRegister().then(res => {
                if (res) {
                  this.initProject()
                  this.dialogLoading = false
                }
              }).catch(res => {
                if (res) {
                  this.initProject()
                  this.dialogLoading = false
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
              })
            }
          })
        }
      })
    },
    showDetails: function (item) {
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        this.project = item
        this.Details_Cordi = true;
        this.JoinPerson = []
        var url = ''
        this.initRequestProject({
          Project_code: this.project.Project_code
        })
        this.initJoinProject({
          Project_code: item.Project_code
        }).then(resJoin => {
          if (resJoin) {
            if (item.IsRoundStatus == '0') {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                this.JoinPerson.unshift({
                  ...Join_i,
                  full_Name: Join_i.name + ' ' + Join_i.sname,
                  idCard: Join_i.id_card,
                  status_reg_person: '0'
                })
              })
            } else {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_project_round_id/' + item.Ref_id + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                if (Join_i.D_project_round_id == item.Ref_id) {
                  this.JoinPerson.unshift({
                    ...Join_i,
                    full_Name: Join_i.name + ' ' + Join_i.sname,
                    idCard: Join_i.id_card,
                    status_reg_person: '0'
                  })
                }
              })
            }
            axios.get(url).then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.JoinPerson.map(Join_i => {
                    res.data.map((item) => {
                      if (Join_i.uid == item.uid) {
                        Join_i.status_reg_person = item.status_reg_person
                      }
                    })
                  })
                } else {
                  this.JoinPerson.map(Join_i => {
                    if (Join_i.uid == res.data.uid) {
                      Join_i.status_reg_person = res.data.status_reg_person
                    }
                  })
                }
              }
            })
          }
        })
      }
    },
    updateDataToDB2(RegObj, status) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        if (this.JoinPerson.length > 0) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, '', headerAxios).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, {
                status_reg: status,
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  if (status == '0') {
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register_view/Project_code/' + this.project.Project_code + '/active/1', '', headerAxios).then(resProjectReg => {
                      if (resProjectReg.data) {
                        if (resProjectReg.data.length > 0) {
                          var CountStatus = false
                          var CountItem = 0
                          resProjectReg.data.map(ProjectReg => {
                            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + ProjectReg.D_Project_Register_id + '/uid/' + RegObj.uid + '/status_reg/1', '', headerAxios).then(res => {
                              if (res.data) {
                                CountStatus = true
                                CountItem++
                              } else {
                                CountItem++
                              }
                              if (CountItem == resProjectReg.data.length && !CountStatus) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                                  join_status: status,
                                }, headerAxios).then(resJoin => {
                                  if (resJoin.data) {
                                    if (RegObj.registerType_id == 0) {
                                      this.ExecHistory_Expert(this.project, RegObj, status)
                                    } else {
                                      this.stampLogRegister(this.project, RegObj, status, null, null, null)
                                    }
                                    resolve(true)
                                  } else {
                                    resolve(true)
                                  }
                                })
                              } else {
                                resolve(true)
                              }
                            })
                          })
                        } else {
                          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + resProjectReg.data.D_Project_Register_id + '/uid/' + RegObj.uid + '/status_reg/1', '', headerAxios).then(res => {
                            if (res.data) {
                              CountStatus = true
                            }
                            if (!CountStatus) {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                                join_status: status,
                              }, headerAxios).then(resJoin => {
                                if (resJoin.data) {
                                  if (RegObj.registerType_id == 0) {
                                    this.ExecHistory_Expert(this.project, RegObj, status)
                                  } else {
                                    this.stampLogRegister(this.project, RegObj, status, null, null, null)
                                  }
                                  resolve(true)
                                } else {
                                  resolve(true)
                                }
                              })
                            } else {
                              resolve(true)
                            }
                          })
                        }
                      }
                    })
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                      join_status: status,
                    }, headerAxios).then(resJoin => {
                      if (resJoin.data) {
                        if (RegObj.registerType_id == 0) {
                          this.ExecHistory_Expert(this.project, RegObj, status)
                        } else {
                          this.stampLogRegister(this.project, RegObj, status, null, null, null)
                        }
                        resolve(true)
                      } else {
                        resolve(true)
                      }
                    })
                  }
                } else {
                  resolve(false)
                }
              })
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, {
                uid: RegObj.uid,
                status_reg: status,
                D_Project_Register_id: this.project.D_Project_Register_id,
                Create_BY: this.MeData[0].perid,
                Create_Time: 'now()',
              }, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  if (status == '0') {
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Project_Register_view/Project_code/' + this.project.Project_code + '/active/1', '', headerAxios).then(resProjectReg => {
                      if (resProjectReg.data) {
                        if (resProjectReg.data.length > 0) {
                          var CountStatus = false
                          var CountItem = 0
                          resProjectReg.data.map(ProjectReg => {
                            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + ProjectReg.D_Project_Register_id + '/uid/' + RegObj.uid + '/status_reg/1', '', headerAxios).then(res => {
                              if (res.data) {
                                CountStatus = true
                                CountItem++
                              } else {
                                CountItem++
                              }
                              if (CountItem == resProjectReg.data.length && !CountStatus) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                                  join_status: status,
                                }, headerAxios).then(resJoin => {
                                  if (resJoin.data) {
                                    if (RegObj.registerType_id == 0) {
                                      this.ExecHistory_Expert(this.project, RegObj, status)
                                    } else {
                                      this.stampLogRegister(this.project, RegObj, status, null, null, null)
                                    }
                                    resolve(true)
                                  } else {
                                    resolve(true)
                                  }
                                })
                              } else {
                                resolve(true)
                              }
                            })
                          })
                        } else {
                          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + resProjectReg.data.D_Project_Register_id + '/uid/' + RegObj.uid + '/status_reg/1', '', headerAxios).then(res => {
                            if (res.data) {
                              CountStatus = true
                            }
                            if (!CountStatus) {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                                join_status: status,
                              }, headerAxios).then(resJoin => {
                                if (resJoin.data) {
                                  if (RegObj.registerType_id == 0) {
                                    this.ExecHistory_Expert(this.project, RegObj, status)
                                  } else {
                                    this.stampLogRegister(this.project, RegObj, status, null, null, null)
                                  }
                                  resolve(true)
                                } else {
                                  resolve(true)
                                }
                              })
                            } else {
                              resolve(true)
                            }
                          })
                        }
                      }
                    })
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                      join_status: status,
                    }, headerAxios).then(resJoin => {
                      if (resJoin.data) {
                        if (RegObj.registerType_id == 0) {
                          this.ExecHistory_Expert(this.project, RegObj, status)
                        } else {
                          this.stampLogRegister(this.project, RegObj, status, null, null, null)
                        }
                        resolve(true)
                      } else {
                        resolve(true)
                      }
                    })
                  }
                } else {
                  resolve(false)
                }
              })
            }
          })
        }
      })
    },
    async ExecHistory_Expert(project, person, status) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + project.Project_code + '/perid/' + person.uid + '/type/' + ((this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17') + '/?sort=id_Desc&limit=1').then(res => {
        if (res.data) {
          if (res.data.active == '0') {
            if (status == '1') {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + res.data.id, {
                D_Project_Register_id: project.D_Project_Register_id,
                active: '1',
                update_by: this.MeData[0].perid,
              }, headerAxios)
              this.stampLogRegister(project, person, status, res.data.id, '1', 'U')
            }
          } else {
            if (status == '0') {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + res.data.id, {
                D_Project_Register_id: project.D_Project_Register_id,
                active: '0',
                update_by: this.MeData[0].perid,
              }, headerAxios)
              this.stampLogRegister(project, person, status, res.data.id, '0', 'U')
            }
          }
        } else {
          if (status == '1') {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
              perid: person.uid,
              Project_code: project.Project_code,
              D_Project_Register_id: project.D_Project_Register_id,
              type: (project.Project_group == '106' || project.Project_group == '107' || project.Project_group == '109') ? '18' : '17',
              subject: project.Project_name,
              date_start: project.DateStart,
              date_end: project.DateEnd,
              date_travel_start: '',
              date_travel_end: '',
              time_start: '',
              time_end: '',
              Rm: '',
              Ref_id: this.getRandomFileName(),
              active: '1',
              create_by: this.MeData[0].perid,
              create_time: 'now()',
            }, headerAxiosPUT)
            this.stampLogRegister(project, person, status, null, '1', 'P')
          }
        }
      })
    },
    stampLogRegister(project, person, status, ex_id, ex_status_id, ex_type) {
      return new Promise(resolve => {
        const headerAxiosPUT = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Register/', {
          Project_code: project.Project_code,
          uid: person.uid,
          D_Project_Register_id: project.D_Project_Register_id,
          Status_Reg: status,
          History_Experts_id: ex_id,
          Status_Expert: ex_status_id,
          Type_Expert: ex_type,
          create_by: this.MeData[0].perid,
        }, headerAxiosPUT).then(res => {
          if (res.data.status) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(res => {
          if (res) {
            resolve(false)
          }
        })
      })
    },
    requestRegChecking(project, uid) {
      return new Promise(resolve => {
        if (project.IsRoundStatus == '0') {
          if (this.RequestProject.length > 0 && this.RequestProject.filter(reqI => reqI.perid == uid && (reqI.D_project_round_id == '' || reqI.D_project_round_id == null)).length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          if (this.RequestProject.length > 0) {
            var RequestDump = this.RequestProject.filter(RequestI => RequestI.D_project_round_id == project.Ref_id)
            if (RequestDump.length > 0 && RequestDump.filter(reqI => reqI.perid == uid).length > 0) {
              resolve(true)
            }
          } else {
            resolve(false)
          }
        }
      })
    },
    updateDataToDB(RegObj) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        if (this.JoinPerson.length > 0) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, '', headerAxios).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, {
                status_reg: '1',
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                    join_status: '1',
                  }, headerAxios).then(async resJoin => {
                    if (resJoin.data) {
                      if (RegObj.registerType_id == 0) {
                        await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.project.Project_code + '/perid/' + RegObj.uid + '/type/' + ((this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17') + '/?sort=id_Desc&limit=1').then(res => {
                          if (res.data) {
                            if (res.data.active == '0') {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + res.data.id, {
                                active: '1',
                                update_by: this.MeData[0].perid,
                              }, headerAxios)
                            }
                          } else {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                              perid: RegObj.uid,
                              Project_code: this.project.Project_code,
                              D_Project_Register_id: this.project.D_Project_Register_id,
                              type: (this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17',
                              subject: this.project.Project_name,
                              date_start: this.project.DateStart,
                              date_end: this.project.DateEnd,
                              date_travel_start: '',
                              date_travel_end: '',
                              time_start: '',
                              time_end: '',
                              Rm: '',
                              Ref_id: this.getRandomFileName(),
                              active: '1',
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      resolve(true)
                    } else {
                      resolve(true)
                    }
                  })
                } else {
                  resolve(false)
                }
              })
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + RegObj.uid, {
                uid: RegObj.uid,
                status_reg: '1',
                D_Project_Register_id: this.project.D_Project_Register_id,
                Create_BY: this.MeData[0].perid,
                Create_Time: 'now()',
              }, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + RegObj.uid + (this.project.RoundStatus ? '/D_project_round_id/' + this.project.Ref_id : ''), {
                    join_status: '1',
                  }, headerAxios).then(async resJoin => {
                    if (resJoin.data) {
                      if (RegObj.registerType_id == 0) {
                        await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.project.Project_code + '/perid/' + RegObj.uid + '/type/' + ((this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17') + '/?sort=id_Desc&limit=1').then(res => {
                          if (res.data) {
                            if (res.data.active == '0') {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + res.data.id, {
                                active: '1',
                                update_by: this.MeData[0].perid,
                              }, headerAxios)
                            }
                          } else {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                              perid: RegObj.uid,
                              Project_code: this.project.Project_code,
                              D_Project_Register_id: this.project.D_Project_Register_id,
                              type: (this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17',
                              subject: this.project.Project_name,
                              date_start: this.project.DateStart,
                              date_end: this.project.DateEnd,
                              date_travel_start: '',
                              date_travel_end: '',
                              time_start: '',
                              time_end: '',
                              Rm: '',
                              Ref_id: this.getRandomFileName(),
                              active: '1',
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      resolve(true)
                    } else {
                      resolve(true)
                    }
                  })
                } else {
                  resolve(false)
                }
              })
            }
          })

        }
      })
    },
    insertDataToDB(RegObj) {
      return new Promise(resolve => {
        const headerAxiosPUT = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        if (this.JoinPerson.length > 0) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj, headerAxiosPUT).then(res => {
            if (res.data.status) {
              if (RegObj.registerType_id == 0) {
                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.project.Project_code + '/perid/' + RegObj.uid + '/type/' + ((this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17' + '/D_Project_Register_id/' + this.project.D_Project_Register_id) + '/?sort=id_Desc&limit=1').then(res => {
                  if (res.data) {
                    if (res.data.active == '0')
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + res.data.id, {
                        active: '1',
                        update_by: this.MeData[0].perid,
                      }, headerAxios)
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                      perid: RegObj.uid,
                      Project_code: this.project.Project_code,
                      D_Project_Register_id: this.project.D_Project_Register_id,
                      type: (this.project.Project_group == '106' || this.project.Project_group == '107' || this.project.Project_group == '109') ? '18' : '17',
                      subject: this.project.Project_name,
                      date_start: this.project.DateStart,
                      date_end: this.project.DateEnd,
                      date_travel_start: '',
                      date_travel_end: '',
                      time_start: '',
                      time_end: '',
                      Rm: '',
                      Ref_id: this.getRandomFileName(),
                      active: '1',
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, headerAxiosPUT)
                  }
                })
              }
              resolve(true)
            } else {
              resolve(false)
            }
          })
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    selProjFiscalYear() {
      this.dialogLoading = true
      this.Project_code_reg = null
      this.dateReg = ''
      this.dateEndReg = ''
      this.initExportList({
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
        type: 'admin',
        FiscalYear: this.FiscalYear
      }).then(resExproj => {
        if (resExproj) {
          this.projectRegDataDump = this.ProjectExport
          this.dialogLoading = false
        }
      })
      this.initAllProjForRegister({
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
        type: 'admin',
        FiscalYear: this.FiscalYear
      }).then(resExproj => {
        if (resExproj) {
          this.projectDataToTable = this.ProjForRegister
        }
      })
    }
  },
  mounted() {
    this.dialogLoading = true
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: '0'
    })
    for (var l = 2020; l <= (new Date().getFullYear() + 3); l++) {
      this.FiscalYearDataSel.push({
        year: l,
        yearth: l + 543
      })
    }
    this.FiscalYear = new Date().getFullYear()
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10',
          page_sub_id: '10',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '7000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                      this.dialogLoading = false
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                    this.dialogLoading = false
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                          this.dialogLoading = false
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                        this.dialogLoading = false
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
